import React from 'react'

import { Button, SelectInput } from '@fielded/shared-ui'
import { getCycleOptions, getReportingPeriodicTypes } from '../common/utils'

class ReportingPeriodJumper extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      month: null,
      year: null,
      date: null,
      yearLimit: 2016
    }
  }

  setYear = ({ value }) => {
    this.setState({ year: value })
  }

  setCycle = (event, isWeekly) => {
    const { value } = event

    if (isWeekly) {
      return this.setState({ date: value })
    }
    this.setState({ month: value })
  }

  getYears = () => {
    let currentYear = new Date().getFullYear()
    const yearsOptions = []
    while (currentYear >= this.state.yearLimit) {
      yearsOptions.push({ label: currentYear, value: currentYear })
      currentYear = currentYear - 1
    }
    return yearsOptions
  }

  render () {
    const { month, year, date } = this.state
    const { handlePeriodJump, program } = this.props
    const cycleOptions = getCycleOptions(program, year)
    const { isWeekly } = getReportingPeriodicTypes(program)

    return (
      <div className='timeframe__date-picker'>
        <div className='date-picker__time-wrapper'>
          <SelectInput
            clearable={false}
            options={this.getYears()}
            onChange={this.setYear}
            className={'date-picker__years'}
            placeholder={'Select a year...'}
            creatable={false}
          />
          <SelectInput
            clearable={false}
            options={cycleOptions}
            onChange={(event) => this.setCycle(event, isWeekly)}
            className={'date-picker__cycles'}
            placeholder={'Select a cycle...'}
            creatable={false}
          />
        </div>
        <div className='date-picker__buttons-wrapper'>
          <Button
            onClick={() => handlePeriodJump(month, year, date)}
            colorVariant='brand'
            fill='outline'
            disabled={isWeekly ? !date : (!month || !year)}
          >
              Go
          </Button>
        </div>
      </div>
    )
  }
}

export default ReportingPeriodJumper
